var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"dot-list"},_vm._l((_vm.relatedTests),function(test){return _c('li',{key:test.title},[_c('router-link',{attrs:{"to":test.path}},[_vm._v(_vm._s(test.title))])],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b8b80e0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/test/Endocrinology/EndocrinologyRelatedTests.vue
// module id = null
// module chunks = 